export default class Interface
{
    getSlug()
    {
        console.warn('getSlug not implemented');
    }
    getName()
    {
        console.warn('getName not implemented');
    }
    getLogo()
    {
        console.warn('getLogo not implemented');
    }
    getPinIcon()
    {
        console.warn('getPin not implemented');
    }
    
    getPins()
    {
        console.warn('getPins not implemented');
    }
}